import Vue from 'vue';

/**
 * @module Store/documents
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    documents: [],
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getDcouments: state => state.documents,
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    setDcouments: (state, documents) => state.documents = documents,
};

/**
 * @constant Actions
 * @type {object}
 
 * */
const actions = {
    async getDcoumentsAsync({ commit, dispatch, rootState }) {
        try {
            try {
                let { data } = await Vue.axios.get("/utilities/syncmapper/documents")

                const preparedData = data.map(page => {
                    return { 
                        name: page.title.rendered,
                        link: page.mapperSlug,
                        keyaccount: page.keyaccount,
                        lang: page.lang,
                        brand: page.brand,
                        id: page.id
                    }
                })

                commit('setDcouments', preparedData);
                return preparedData;

            } catch (error) {
                commit('setDcouments', []);
                return [];
            }
        } catch (err) {
            commit('setDcouments', []);
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
